<template>
  <div class="bk-icon" :class="'bk-icon-' + name" v-html="markup" />
</template>

<script setup>
import { computed } from "#imports";
import { icons } from "#blokkli-build/icons";
const props = defineProps({
  name: { type: null, required: true }
});
const markup = computed(() => icons[props.name]);
</script>

<script>
export default {
  name: "Icon"
};
</script>
